import React, { useState } from 'react'
import { Author } from '@fable/types'
import { FlexBox, Text } from '@fable/components'
import Loader, { LoaderType } from '../../../../../components/loader'
import ShareButton from '../../../../../components/share_button/ShareButton'

import defaultAuthorBackground from '../../../../../assets/images/graphics/placeholders/default-author-background.webp'
import { getInitials } from '../../../../../utils'

import { CATEGORIES } from '../../../../../constants'

interface Props {
  info: Author
}

export const AuthorMasthead: React.VFC<Props> = ({ info }) => {
  const [isImageLoaded, setIsImageLoaded] = useState(false)
  const [isFallback, setIsFallback] = useState(false)

  const { name, image } = info

  const onImageLoaded = () => {
    setIsImageLoaded(true)
  }

  const onImageFallback = (e: React.SyntheticEvent<HTMLImageElement>) => {
    const target = e.target as HTMLImageElement
    target.src = defaultAuthorBackground
    setIsFallback(true)
  }

  const renderLoader = !isImageLoaded && (
    <Loader isLight={true} type={LoaderType.contained} />
  )

  const loaded = isImageLoaded ? 'loaded' : ''
  const defaultImage = !image ? 'default' : ''

  return (
    <section>
      <div className="content">
        <div className={`image-wrap ${loaded} ${defaultImage}`}>
          {renderLoader}
          <img
            className="image"
            src={image ? image : defaultAuthorBackground}
            alt={name}
            onError={(e) => onImageFallback(e)}
            onLoad={onImageLoaded}
          />
          {(isFallback || !image) && (
            <Text
              className="author-initials"
              type="header"
              sizing="XL"
              text={getInitials(name)}
            />
          )}
        </div>

        <Text
          className="author-name"
          type="header"
          sizing={{ base: 'M', mobileL: 'L' }}
        >
          {name}
        </Text>
        <Text className="author-role" type="label" sizing="L">
          Author
        </Text>
      </div>
      <FlexBox justifyContent="center">
        <ShareButton category={CATEGORIES.author} />
      </FlexBox>
    </section>
  )
}
